<div class="preferiti d-none d-md-block mb-4" *ngIf="preferiti && preferiti.length > 0 && isLoggedIn">
  <div class="row">
    <div class="col-12">
      <h6 class="text-stem">{{'MIEI_PREFERITI' | translate | htmlToText}} ({{preferiti.length}} {{'PRODOTTI' | translate | htmlToText}})</h6>
    </div>
  </div>
  <div class="row" *ngFor="let preferito of preferiti">
    <div class="col-4">
      <img *ngIf="preferito.foto" [appSrcMobileLandscape43]="preferito.foto[0]?.path" [alt]='preferito.foto[0]?.alt' class="square">
    </div>
    <div class="col-8">
      <small class="text-stem">{{preferito.titolo}}</small><br>
      <!-- Senza prezzo promo -->
      <span *ngIf="!(preferito.infoCommerciali?.PREZZO_PROMO?.valore)">
        {{preferito.infoCommerciali?.PREZZO?.valore | currency:'EUR'}}
      </span>
      <!-- Con prezzo promo -->
      <span class="sconto mr-4" *ngIf="preferito.infoCommerciali?.PREZZO_PROMO?.valore">
        <span class="sconto mr-4">{{preferito.infoCommerciali?.PREZZO?.valore | currency:'EUR'}}</span>
      </span>
      <span *ngIf="preferito.infoCommerciali?.PREZZO_PROMO?.valore">
        {{preferito.infoCommerciali?.PREZZO_PROMO?.valore | currency:'EUR'}}
      </span>
      <br>
      <span class="small"><a (click)="aggiungiAlCarrello(preferito)" class="text-underline text-stem-red">{{'AGGIUNGI_AL_CARRELLO' | translate | htmlToText}}</a></span>
      <br>
      <span class="small"><a (click)="rimuovi(preferito)" class="text-underline">{{'RIMUOVI' | translate | htmlToText}}</a></span>
      <br>
    </div>
  </div>
</div>